import { render, staticRenderFns } from "./IdentityDetailModal.vue?vue&type=template&id=c05b1c54&"
import script from "./IdentityDetailModal.vue?vue&type=script&lang=js&"
export * from "./IdentityDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports